<template>
  <div class="template-form-pasres">
    <div class="template-form-pasres-container">
      <h2 class="template-form-pasres-title">修改密码</h2>

      <el-form
        ref="pasResForm"
        :model="pasResForm"
        label-width="22.3rem"
        class="template-form-pasres-form"
        :rules="rules"
      >
        <el-form-item label="登录帐户：">
          <el-input v-model="binyi_cms_loginInfo.name" disabled></el-input>
        </el-form-item>

        <el-form-item prop="oldPwd" label="原始密码：">
          <el-input
            :type="passw"
            v-model="pasResForm.oldPwd"
            placeholder="请输入原始密码"
            maxlength="30"
            @input="
              (v) => {
                this.pasResForm.oldPwd = v.replace(
                  /[\u4E00-\u9FA5\uF900-\uFA2D\s]/g,
                  ''
                );
              }
            "
          ></el-input>
          <img
            class="iv_eye"
            src="@/assets/images/UserLogin/iv_eye_close.png"
            alt=""
            @click="showPass(1)"
            v-if="passw != 'text'"
          />
          <img
            class="iv_eye"
            src="@/assets/images/UserLogin/iv_eye_open.png"
            alt=""
            @click="showPass(1)"
            v-if="passw == 'text'"
          />
        </el-form-item>

        <el-form-item prop="newPwd" label="新密码：">
          <el-input
            :type="passwa"
            v-model="pasResForm.newPwd"
            placeholder="请输入新密码"
            maxlength="30"
            @input="
              (v) => {
                this.pasResForm.newPwd = v.replace(
                  /[\u4E00-\u9FA5\uF900-\uFA2D\s]/g,
                  ''
                );
              }
            "
          ></el-input>
          <img
            class="iv_eye"
            src="@/assets/images/UserLogin/iv_eye_close.png"
            alt=""
            @click="showPass(2)"
            v-if="passwa != 'text'"
          />
          <img
            class="iv_eye"
            src="@/assets/images/UserLogin/iv_eye_open.png"
            alt=""
            @click="showPass(2)"
            v-if="passwa == 'text'"
          />
        </el-form-item>

        <el-form-item prop="newPwdAgain" label="确认新密码：">
          <el-input
            :type="passwb"
            v-model="pasResForm.newPwdAgain"
            placeholder="请再次输入新密码"
            maxlength="30"
            @input="
              (v) => {
                this.pasResForm.newPwdAgain = v.replace(
                  /[\u4E00-\u9FA5\uF900-\uFA2D\s]/g,
                  ''
                );
              }
            "
          ></el-input>
          <img
            class="iv_eye"
            src="@/assets/images/UserLogin/iv_eye_close.png"
            alt=""
            @click="showPass(3)"
            v-if="passwb != 'text'"
          />
          <img
            class="iv_eye"
            src="@/assets/images/UserLogin/iv_eye_open.png"
            alt=""
            @click="showPass(3)"
            v-if="passwb == 'text'"
          />
        </el-form-item>
      </el-form>
      <div class="template-form-pasres-button">
        <el-button @click="onSubmit(false)">取消</el-button>
        <el-button type="primary" @click="onSubmit(true)">确定</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import mixin from "./Mixins";

export default {
  mixins: [mixin],
  data() {
    var validatePasswordAgain = (rule, value, callback) => {
      if (value !== this.pasResForm.newPwd) {
        callback(new Error("新密码必须保持一致"));
      } else {
        callback();
      }
    };
    var validatePasswordRule = (rule, value, callback) => {
      let count = 0;
      if (/[a-zA-Z]/g.test(value)) {
        count = count + 1;
      }
      if (/[0-9]/g.test(value)) {
        count = count + 1;
      }
      if (count >= 2) {
        callback();
        return;
      } else if (count == 0) {
        callback(new Error("密码必须为8~30位数字、字母、特殊字符任意两个组合"));
        return;
      }
      let restStr = value.replace(/[0-9a-zA-Z]/g, "");
      if (restStr.length > 0) {
        callback();
      } else {
        callback(new Error("密码必须为8~30位数字、字母、特殊字符任意两个组合"));
      }
    };
    return {
      rules: {
        oldPwd: [{ required: true, message: "请输入原密码", trigger: "blur" }],
        newPwd: [
          { required: true, message: "请输入新密码", trigger: "blur" },
          {
            min: 8,
            max: 30,
            message: "密码必须为8~30位数字、字母、特殊字符任意两个组合",
            trigger: "blur",
          },
          {
            validator: validatePasswordRule,
            trigger: "blur",
          },
        ],
        newPwdAgain: [
          { required: true, message: "请再次输入新密码", trigger: "blur" },
          {
            min: 8,
            max: 30,
            message: "密码必须为8~30位数字、字母、特殊字符任意两个组合",
            trigger: "blur",
          },
          { validator: validatePasswordAgain, trigger: "blur" },
        ],
      },
      passw: "password",
      passwa: "password",
      passwb: "password",
    };
  },
  computed: {
    pasResForm() {
      return this.UserLogin.pasResForm;
    },
    binyi_cms_loginInfo() {
      return this.UserLogin.binyi_cms_loginInfo;
    },
  },
  created() {
    this.setLeftMenuShow_M(false);
    this.SETOPTIONS({
      pasResForm: {
        adminId: 0,
        oldPwd: "",
        newPwd: "",
        newPwdAgain: "",
      },
    });
  },
  methods: {
    onSubmit(boo) {
      if (boo) {
        this.$refs.pasResForm.validate((result) => {
          if (result) {
            this.SETADMINID(this.binyi_cms_loginInfo.id);
            this.sendPasRes();
          }
        });
      } else {
        this.SETADMINID(0);
        this.sendPasRes();
      }
    },
    showPass(v) {
      //点击图标是密码隐藏或显示
      if (v == 1) {
        if (this.passw == "text") {
          this.passw = "password";
        } else {
          this.passw = "text";
        }
      } else if (v == 2) {
        if (this.passwa == "text") {
          this.passwa = "password";
        } else {
          this.passwa = "text";
        }
      } else if (v == 3) {
        if (this.passwb == "text") {
          this.passwb = "password";
        } else {
          this.passwb = "text";
        }
      }
    },
  },
};
</script>
<style lang="stylus" scoped>
.template-form-pasres {
  width: 100%;
  background-color: #fff !important;

  .iv_eye {
    width: 53px;
    height: 40px;
    position: absolute;
    padding-right: 20px;
    padding-left: 20px;
    padding-top: 16px;
    padding-bottom: 16px;
    box-sizing: border-box;
    right: 110px;
    bottom: 0px;
  }

  .template-form-pasres-container {
    margin: 20px auto;
    background-color: #FAFBFF;
    width: 560px;
    height: 640px;
    border: 1px solid #fff;

    .template-form-pasres-title {
      margin: 94px auto 0;
      text-align: center;
      font-size: 30px;
      color: #000000;
      font-weight: 500;
      height: 42px;
      line-height: 42px;
    }

    .template-form-pasres-form {
      margin-top: 70px;

      .el-input {
        width: 220px;
        height: 40px;
      }
    }

    .template-form-pasres-button {
      margin: 72px auto 0;

      .el-button {
        width: 100px;
        height: 40px;
        margin-left: 155px;
      }

      .el-button+.el-button {
        margin-left: 50px;
      }
    }
  }
}
</style>







// WEBPACK FOOTER //
// src/pages/UserLogin/components/FromPasRes.vue